// @import dependencies
import React, { Component } from 'react'
import { connect } from 'react-redux'
// @end

// @import components
import { PublicAppLayout } from '../index'
// @end

// @ADD Component types
interface PublicAppProps {
  dispatch?: any,
  children?: any
}
interface PublicAppState {}
class PublicAppContainer extends Component<PublicAppProps, PublicAppState> {

  constructor(props: any) {
    super(props)

    this.state = {}
  }

  render() {
    return (
      <PublicAppLayout
        {...this.props}
      />
    )
  }
}

const mapStatesToProps = (state: any) => {
  return state
}


export default connect(mapStatesToProps)(PublicAppContainer)
